import React from 'react';

//CORE COMPONENTS
import { ThemeProvider, styled } from '../../../../../components-core/packages/components-core/dist/theme-provider/index';
import {
    Container,
    ContainerWrap,
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment,
    ContainerVerticalAlignment
} from '../../../../../components-core/packages/components-core/dist/container/index';
import { IntegratorRoot } from '../../../../../components-core/packages/components-core/dist/integrator-root/index';
import { Text, TextAppearance, TextAlignment } from '../../../../../components-core/packages/components-core/dist/text';
import { Breakpoints } from '../../../../../components-core/packages/components-core/dist/helpers';
import { Layout } from '../../../../../components-core/packages/components-core/dist/layout/index';
import { AspectRatioContainer, AspectRatio } from '../../../../../components-core/packages/components-core/dist/aspect-ratio-container/index';
import { Image } from '../../../../../components-core/packages/components-core/dist/image/index';
import { FixedWidthContainer } from '../../../../../components-core/packages/components-core/dist/fixed-width-container/index';
import { BreakpointWrapper } from '../../../../../components-core/packages/components-core/dist/breakpoint-wrapper/index';
import PriceListOptionalAccrodion from '../../../price-list-optional-accordion/PriceListOptionalAccrodion'


const TopContainer = styled.div`
    width: 100%;
    background-color: #001e50;
`;


class TableHeader extends React.Component {

    render() {
        return (
            <ThemeProvider theme="image">
                <TopContainer>
                    <Container
                        stretchContent={true}
                        padding={{
                            top: ContainerPadding.dynamic0050,
                            bottom: ContainerPadding.dynamic0050,
                            left: ContainerPadding.dynamic0100
                        }}
                        verticalAlign={ContainerVerticalAlignment.center}
                    >
                        <Text appearance={TextAppearance.headline0250} bold>{this.props.name}</Text>

                    </Container>
                </TopContainer>
            </ThemeProvider>
        )
    }
}




export default TableHeader;